import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import DiseaseDetailDialog from "../../../../../../common/diseaseDetailDialog/DiseaseDetailDialog";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import IconButton from "@material-ui/core/IconButton";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import { changeSelectedDiseasesAction } from "../../../../../../../reducers/searchOmimState";

const useStyles = makeStyles((theme) => ({
  diseaseBlock: {
    display: "flex",
    alignItems: "center",
  },
  disease: {
    width: "100%",
    borderRadius: 30,
    padding: theme.spacing(1, 2),
    backgroundColor: "#F3F2FC",
    border: "1px solid #FFF",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  selectedContent: {
    height: "100%",
    display: "grid",
    gap: "0.5rem",
  },
}));

const SelectedDiseasesComponent = () => {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();

  const selectedDiseases = useSelector((state) => state.searchOmim.selectedDiseases);

  const [diseaseId, setDiseaseId] = useState(null);
  const [title, setTitle] = useState(null);
  const [symptoms_score, setSymptoms_score] = useState(0);

  const handleOpenDiseaseModal = (disease) => {
    setDiseaseId(disease.id);
    setTitle(disease?.title || "");
    setSymptoms_score(disease?.symptoms_score);
  };

  const handleCloseDiseaseModal = () => {
    setDiseaseId(null);
    setTitle(null);
    setSymptoms_score(0);
  };

  const handleRemoveDisease = (disease) => {
    const newDiseases = selectedDiseases.filter((d) => d.id !== disease.id);
    dispatch(changeSelectedDiseasesAction(newDiseases));
  };

  return (
    <>
      <Typography variant={"h2"}>{intl.formatMessage({ id: "selectedDiseases" })}</Typography>
      <div className={classes.selectedContent}>
        {selectedDiseases.map((d) => (
          <div className={classes.diseaseBlock} key={d.id}>
            <div className={classes.disease}>
              <Typography>{d.title}</Typography>
            </div>
            <IconButton onClick={() => handleOpenDiseaseModal(d)}>
              <VisibilityOutlinedIcon color={"secondary"} />
            </IconButton>
            <IconButton onClick={() => handleRemoveDisease(d)}>
              <HighlightOffRoundedIcon />
            </IconButton>
          </div>
        ))}
      </div>
      <DiseaseDetailDialog
        title={title}
        diseaseId={diseaseId}
        handleCloseDiseaseModal={handleCloseDiseaseModal}
        symptoms_score={symptoms_score}
      />
    </>
  );
};

export default SelectedDiseasesComponent;
